module.exports = __webpack_public_path__ + "static/features-schematic.64e8e0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features-schematic.png
// module id = 666
// module chunks = 72138227098318